import { useDismissEngagement } from './useDismissEngagement'

type UseDismissMentionResult = {
  dismissMention: (mentionId: string) => Promise<boolean>
  loading: boolean
}

/**
 * Mention-specific specialization over `useDismissEngagement`. Hardcodes
 * `engagementType: 'mention'` so call sites stay readable
 * (`dismissMention(mention.id)` instead of the kind-agnostic shape).
 *
 * When comments migrates off the legacy `dismissComment` mutation, mirror
 * this file as `useDismissComment` — same wrapper pattern, swap the
 * engagementType.
 */
export const useDismissMention = (): UseDismissMentionResult => {
  const { dismissEngagement, loading } = useDismissEngagement()

  const dismissMention = (mentionId: string): Promise<boolean> =>
    dismissEngagement({
      engagementId: mentionId,
      engagementType: 'mention',
    })

  return { dismissMention, loading }
}
